export function addressShortener(address: string): string {
  return address.substring(0, 6) + `...` + address.substring(38);
}
